import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//import { IAppointmentData,IAppointmentData2 } from 'src/app/models/IAppointmentDetails';
import { IAppointmentData, IAppointmentDataPB, IAppointmentRemarks, IAppointmentStatusLogs, IExportexcelWorklist, IPAddressList, NextAppointment } from 'src/app/models/IAppointmentDetails';
import { IUserDetails } from 'src/app/models/IUsersDetails';

import { Observable } from 'rxjs';

import { IVisitTypes } from 'src/app/models/IVisitTypes';
import { IRoomsInfo } from 'src/app/models/IRoomsInfo';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { IAttributes } from 'src/app/models/IAttributes';
import { IElement } from 'src/app/models/IElement';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { IProviderDetails } from 'src/app/models/IProviderDetails';
import { configuration } from 'src/environments/environment';
import { Defaults } from 'src/app/Utilities/defaults';
import { CalendarTemplate, CalendarTemplateDay } from 'src/app/models/CalendarTemplate';
import { appiontMentResultDTO } from 'src/app/models/AppiontMentResultDTO';
import { IHolidays } from 'src/app/models/IHolidays';
import { IAvailableSlots } from 'src/app/models/IAvailableSlots';

import { ScheduleReportExcelRequest } from 'src/app/models/ScheduleReportExcelRequest';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { SendMessageRequest } from 'src/app/Calender/new-appointment/new-appointment.component';
import { I } from '@angular/cdk/keycodes';

@Injectable({
  providedIn: 'root'
})
export class SchedularServiceService {

  constructor(private http: HttpClient, private shrddrv: SharedService) { }

  // Insert appointment
  insertAppointment(appointmentInfo: IAppointmentData, isAppCreate: boolean): any {
    if (appointmentInfo.reminderInterval == "")
      appointmentInfo.reminderInterval = null;

    const posteddata = {
      inputdata: JSON.stringify(appointmentInfo)
    }
    return this.http.post<appiontMentResultDTO>(`${configuration.apiUrl + 'Scheduler/Appointment'}?isAppCreate=${isAppCreate}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  SendPatientSMS(patmessageObj: SendMessageRequest): Observable<string> {
    return this.http.post<string>(`${configuration.patientPortalApiUrl + 'SendMessage'}`, patmessageObj, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });

  }
  // insertAppointment2(appointmentInfo: IAppointmentData2): any {
  //   return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/Appointment'}`, appointmentInfo, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }
  // Get visit types by facility Id
  getVisitTypes(): Observable<IVisitTypes[]> {
    return this.http.get<IVisitTypes[]>(
      `${configuration.apiUrl + 'Master/MasterVisitTypes'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }


  // Get rooms by facility Id
  getRooms(locationId: number): Observable<IRoomsInfo[]> {
    return this.http.get<IRoomsInfo[]>(
      `${configuration.apiUrl + 'Master/Rooms'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${locationId}`);
  }

  // Get locations by facility Id
  getLocations(ascFacilityId:number = 0): Observable<ILocationDetails[]> {
    if (!(sessionStorage.getItem("userId") || sessionStorage.getItem("FacilityId"))) {
      return null;
    }
    const facId = ascFacilityId > 0 ? ascFacilityId : sessionStorage.getItem("FacilityId");
    return this.http.get<ILocationDetails[]>(
      `${configuration.apiUrl + 'Master/LocationInfo'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${facId}`);
  }

  // Get patient board details for given date
  getAppointmentDetails(apptab: string, role: string, cday: string, userid: string, schdflag: boolean): Observable<IAppointmentData[]> {
    return this.http.get<IAppointmentData[]>(
      `${configuration.apiUrl + 'Scheduler/PatientboardAppointments'}?apptab=${apptab}&&role=${role}&&cday=${cday}&&userid=${userid}&&schdflag=true&&clinictimeduration=${Defaults.clinictimeduration}&&facilityId=${sessionStorage.getItem("FacilityId")}`);

  }
  getLocationsByprovider(userid: string): Observable<ILocationDetails[]> {
    return this.http.get<ILocationDetails[]>(
      `${configuration.apiUrl + 'Admin/LocationsByProvider'}?userid=${userid}`);

  }
  // Create encounter for appointment
  createEncounter(appId: string, patId: number, providerId: string, createdBy: string, categoryId: number, newVisit: boolean): Observable<IAppointmentData[]> {
    return this.http.get<IAppointmentData[]>(
      `${configuration.clinicapiUrl + 'Encounter/CreateEncounter'}?appId=${appId}&&patId=${patId}&&providerId=${providerId}&&createdBy=${createdBy}&&categoryId=${categoryId}&&newVisit=${newVisit}`);
  }

  // Get appointment status by attribute Id
  getAppStatusAttributes(): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.apiUrl + 'Master/AttributesByType'}?attributeid=${Defaults.appStatusMasterId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId"))}`);
  }

  // Get appointment details by appointment date and providers
  getAppointmentDetailsBySearch(appDate: string, userList: string, schdflag: boolean, appstatusList: string, IsProvider: boolean, IsNurse: boolean): Observable<IAppointmentData[]> {
    const postedData = {
      appDate: appDate,
      userList: userList,
      schdFlag: schdflag,
      appstatusList: appstatusList,
      isProvider: IsProvider,
      isNurse: IsNurse,
      ClinicTimeDuration: -360,
      facilityId: sessionStorage.getItem("FacilityId"),
      locationId: sessionStorage.getItem("LocationId")

    }
    return this.http.post<IAppointmentData[]>(`${configuration.apiUrl + 'Scheduler/AllProviderAppointments'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
    // return this.http.get<IAppointmentDataPB[]>(
    //   `${configuration.apiUrl + 'Scheduler/AllProviderAppointments'}?appDate=${appDate}&&userList=${userList}&&schdflag=true&&clinictimeduration=${Defaults.clinictimeduration}&&locationId=${sessionStorage.getItem("LocationId")}&&facilityId=${sessionStorage.getItem("FacilityId")}&&appstatusList=${appstatusList}&&isProvider=${IsProvider}&&isNurse=${IsNurse}`);

  }
  getexcelorcsvdata(appDate: string, userList: string,): Observable<IAppointmentData[]> {
    const postedData = {
      appDate: appDate,
      userList: userList,
      schdFlag: '',
      appstatusList: '',
      isProvider: '',
      isNurse: '',
      ClinicTimeDuration: -360,
      facilityId: sessionStorage.getItem("LocationId"),
      locationId: sessionStorage.getItem("LocationId")

    }
    return this.http.post<IAppointmentData[]>(`${configuration.apiUrl + 'Scheduler/excelorcsvdata'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getAppointmentList(appDate: string, providerId: string): Observable<IAppointmentData[]> {
    //fixme facility id???
    const postedData = {
      appDate: appDate,
      userList: encodeURIComponent(providerId),
      schdFlag: true,
      ClinicTimeDuration: -360,
      facilityId: sessionStorage.getItem("FacilityId")

    }
    return this.http.post<IAppointmentData[]>(`${configuration.apiUrl + 'Scheduler/AllProviderAppointments'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
    // const pID = encodeURIComponent(providerId);
    // return this.http.get<IAppointmentData[]>(
    //   `${configuration.apiUrl}Scheduler/AllProviderAppointments?appDate=${appDate}&userList=${pID}&schdflag=true&clinictimeduration=-360&facilityId=${sessionStorage.getItem("FacilityId")}`);

  }
  // Get past encounter details by patient Id and encounter type
  getPastEncountersStatus(patId: number, type: number, userId: string) {
    return this.http.get(
      `${configuration.clinicapiUrl + 'Encounter/EncounterStatusByPatient'}?patId=${patId}&&type=${type}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}}`);

  }

  // Create notes(VistNote/ORNote) for an appointment
  createNote(encounter: IEncounterData): any {
    return this.http.post<string>(
      `${configuration.clinicapiUrl + 'Encounter/CreateNote'}?userId=${encodeURIComponent(sessionStorage.getItem("userId"))}`, encounter,
      {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }


  //*** Get Billing Providers */
  getBillingUsers(): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.apiUrl + 'Scheduler/BillingProviders'}?facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getVisitDetails(encounterId: string): Observable<IAppointmentData> {
    return this.http.get<IAppointmentData>(
      `${configuration.apiUrl + 'Scheduler/VisitDetails'}?encId=${encounterId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId"))}`);
  }

  getCalendarTemplates(providerId: string, locationId: number = 0): Observable<CalendarTemplate[]> {
    //const pID = encodeURIComponent(providerId);
    const postedData = {
      providerId: encodeURIComponent(providerId),
      locationId: locationId,
      templateId: 0,
      userId: 'admin'
    }
    return this.http.post<CalendarTemplate[]>(
      `${configuration.apiUrl}Scheduler/CalenderTemplates`, postedData);
  }

  updateVisitDetails(appointmentInfo: IAppointmentData): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(appointmentInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/VisitDetails'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getCalendarTemplate(templateId: number): Observable<CalendarTemplate[]> {
    const postedData = {
      //providerId: encodeURIComponent(providerId),
      //locationId:locationId,
      templateId: templateId,
      userId: 'admin'
    }
    return this.http.post<CalendarTemplate[]>(
      `${configuration.apiUrl}Scheduler/CalenderTemplates?`, postedData);
  }

  insertCalendarTemplate(calTemplate: CalendarTemplate, mode: string): any {
    const posteddata = {
      inputdata: JSON.stringify(calTemplate)
    }
    return this.http.post<string>(
      `${configuration.apiUrl}Scheduler/CalenderTemplate?userId=admin&&mode=${mode}`, posteddata,
      { headers: new HttpHeaders({ 'content-Type': 'application/json' }) }
    );
  }

  updateCalendarTemplate(calTemplate: CalendarTemplate): any {
    const posteddata = {
      inputdata: JSON.stringify(calTemplate)
    }
    return this.http.post<string>(
      `${configuration.apiUrl}Scheduler/UpdateCalenderTemplate?userId=admin`, posteddata,
      { headers: new HttpHeaders({ 'content-Type': 'application/json' }) }
    );
  }

  checkCalendarTemplate(calTemplate: CalendarTemplate, userId: string): any {
    return this.http.post<string>(
      `${configuration.apiUrl}Scheduler/CheckCalenderTemplate?userId=${userId}`, calTemplate,
      { headers: new HttpHeaders({ 'content-Type': 'application/json' }) }
    );
  }

  getCalendarTemplateByDate(providerId: string, currDate: Date, locationId: number): Observable<CalendarTemplateDay[]> {
    const postedData = {
      providerId: encodeURIComponent(providerId),
      locationId: locationId,
      currentDate: currDate
    }
    return this.http.post<CalendarTemplateDay[]>(
      `${configuration.apiUrl}Scheduler/CalenderByDate`, postedData);
  }

  getCalendarTemplateByMonth(providerId: string, month: string, locationId: number): Observable<CalendarTemplateDay[]> {
    const posteddata = {
      providerId: providerId,
      locationId: locationId,
      month: month
    }
    return this.http.post<CalendarTemplateDay[]>(
      `${configuration.apiUrl}Scheduler/MonthlyAppointments`, posteddata);
  }
  getTemplateByMonth(providerId: string, month: string, locationId: number): Observable<CalendarTemplateDay[]> {
    const posteddata = {
      providerId: providerId,
      locationId: locationId,
      month: month
    }
    return this.http.post<CalendarTemplateDay[]>(
      `${configuration.apiUrl}Scheduler/MonthlyAppointmentsTemplates`, posteddata);
    // return this.http.get<CalendarTemplateDay[]>(
    //   `${configuration.apiUrl}Scheduler/MonthlyAppointmentsTemplates?providerId=${encodeURIComponent(providerId)}&&locationId=${locationId}&&month=${month}`);
  }
  getCalendarTemplatesByWeek(providerId: string, currDate: Date, locationId: number): Observable<CalendarTemplateDay[]> {
    const posteddata = {
      providerId: providerId,
      locationId: locationId,
      currentDate: currDate
    }
    return this.http.post<CalendarTemplateDay[]>(
      `${configuration.apiUrl}Scheduler/CalenderTemplatesByWeek`, posteddata);
    // return this.http.get<CalendarTemplateDay[]>(
    //   `${configuration.apiUrl}Scheduler/CalenderTemplatesByWeek?providerId=${encodeURIComponent(providerId)}&&locationId=${locationId}&&currentDate=${currDate}`);
  }

  blockAppointmentbyDate(providerId: string, currDate: any, locationId: number): Observable<String> {
    const posteddata = {
      providerId: providerId,
      locationId: locationId,
      appDate: currDate,
      userId: encodeURIComponent(sessionStorage.getItem("userId"))
    }
    return this.http.post<String>(
      `${configuration.apiUrl}Scheduler/BlockAppointment`, posteddata);
  }

  getBlockedAppointments(userlist: string, locationId: number): Observable<IAppointmentData[]> {
    const postedData = {
      userlist: encodeURIComponent(userlist).toString(),
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      locationId: sessionStorage.getItem("LocationId")

    }
    return this.http.post<IAppointmentData[]>(
      `${configuration.apiUrl + 'Scheduler/BlockedAppointments'}`, postedData);

    // return this.http.get<IAppointmentData[]>(
    //   `${configuration.apiUrl + 'Scheduler/BlockedAppointments'}?userid=${encodeURIComponent(sessionStorage.getItem("userId"))}&&userlist=${encodeURIComponent(userlist).toString()}&&locationId=${sessionStorage.getItem("LocationId")}`);

  }

  getAppointmentStatusDetails(): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.apiUrl + 'Master/AttributesByStatus'}`);
  }

  UpdateAppointmentStatusdetails(status: string, appointmentInfo: IAppointmentData): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(appointmentInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/AppointmentStatus'}?status=${status}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // Get patient board details for given date
  getAppointmentbyId(appId: string): Observable<IAppointmentData> {
    return this.http.get<IAppointmentData>(
      `${configuration.apiUrl + 'Scheduler/Appointment'}?appointmentId=${appId}`);

  }

  // Update patient board Comments
  UpdatePatientBoardComments(appointmentId: string, comments: string): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Scheduler/PatientBoardComments'}?appointmentId=${appointmentId}&&comments=${comments}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // Get Appointment Rooms
  getAppointmentRoomsDetails(): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.apiUrl + 'Master/AppointmentRooms'}?FacilityId=${sessionStorage.getItem("LocationId")}`);
  }

  //Update Appointment Rooms
  UpdateAppointmentRoom(roomId: string, appointmentId: string): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/AppointmentRooms'}?roomId=${roomId}&&appointmentId=${appointmentId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // update appointment
  updateAppointment(appointmentInfo: IAppointmentData): any {
    if (appointmentInfo.reminderInterval == "")
      appointmentInfo.reminderInterval = null;
    const posteddata = {
      inputdata: JSON.stringify(appointmentInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/UpdateAppointment'}?userId=${encodeURIComponent(sessionStorage.getItem("userId"))}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  searchPatAppointmentDetails(PatId: number, fromDate: string, toDate: string): Observable<IAppointmentData[]> {
    const posteddata = {
      patId: PatId,
      fromDate: fromDate,
      toDate: toDate
    }
    return this.http.post<IAppointmentData[]>(
      `${configuration.apiUrl + 'Scheduler/PatientAppointments'}`, posteddata);

  }

  UpdatecheckinStatus(appointmentId: string, type: string): Observable<string> {
    const posteddata = {
      appointmentId: appointmentId,
      type: type,
      userid: encodeURIComponent(sessionStorage.getItem("userId"))
    }
    return this.http.post<string>(
      `${configuration.apiUrl + 'Scheduler/PatientBoardcheckinOutStatus'}`, posteddata);
  }
  // Deactivate CalenderTemplate
  DeactivateCalenderTemplatesTService(calendarTemplateTd: number, isactive: boolean, userid: string): any {
    const posteddata = {
      calendarTemplateTd: calendarTemplateTd,
      isactive: isactive,
      userid: encodeURIComponent(sessionStorage.getItem("userId"))
    }

    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/DeactivateCalenderTemplate'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getallNoShowAppointmentDetails(fromDate: string, toDate: string): Observable<IAppointmentData[]> {

    const posteddata = {
      fromDate: fromDate,
      toDate: toDate,
      userid: encodeURIComponent(sessionStorage.getItem("userId")),
      locationId: sessionStorage.getItem("LocationId")
    }
    return this.http.post<IAppointmentData[]>(`${configuration.apiUrl + 'Scheduler/NoShowAppointments'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });


  }

  checkForProviderBlock(providerId: string, currDate: any): Observable<IHolidays[]> {
    return this.http.get<IHolidays[]>(
      `${configuration.apiUrl}Scheduler/CheckProviderBlock?providerId=${encodeURIComponent(providerId)}&&appDate=${currDate}`);
  }

  insertAppointmentRemarks(appointmentInfo: IAppointmentRemarks): any {
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/insertAppointmentRemarks'}?facility=${sessionStorage.getItem("FacilityId")}`, appointmentInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getAppointmentsRemarks(appointmentId: string): Observable<IAppointmentRemarks[]> {
    return this.http.get<IAppointmentRemarks[]>(
      `${configuration.apiUrl + 'Scheduler/getAppointmentRemarks'}?AppointmentId=${appointmentId}&&facility=${sessionStorage.getItem("FacilityId")}`);

  }
  UpdateRemarksbyId(appointmentId: string, type: string): Observable<string> {
    const postedData = {
      appointmentId: appointmentId,
      type: type,
      facility: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/PatientBoardRemarks'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getProviderCalendarTemplateByDate(providerId: string, currDate: Date, locationId: number): Observable<CalendarTemplateDay[]> {
    const postedData = {
      providerId: providerId,
      locationId: locationId,
      currentDate: currDate
    }
    return this.http.post<CalendarTemplateDay[]>(
      `${configuration.apiUrl}Scheduler/ProviderCalenderByDate`, postedData);
  }

  getProviderCalendarTemplateByWeek(providerId: string, currDate: Date, locationId: number): Observable<CalendarTemplateDay[]> {
    const postedData = {
      providerId: providerId,
      locationId: locationId,
      currentDate: currDate
    }
    return this.http.post<CalendarTemplateDay[]>(
      `${configuration.apiUrl}Scheduler/ProviderCalenderByWeek`, postedData);
  }

  //******* get Available slots*/
  getAvailableSlotsByDate(providerId: string, locationId: number, currDate: Date, visitId: number): Observable<IAvailableSlots[]> {
    const posteddata = {
      providerId: encodeURIComponent(providerId),
      locationId: locationId,
      currentDate: currDate,
      visitId: visitId
    }
    return this.http.post<IAvailableSlots[]>(
      `${configuration.apiUrl}Scheduler/GetAvailableSlots`, posteddata);
  }

  blockAppointmentbyTemplateId(providerId: string, templateId: number, locationId: number): Observable<String> {
    const posteddata = {
      providerId: providerId,
      ctdayid: templateId,
      locationId: locationId,
      userId: sessionStorage.getItem("userId")
    }
    return this.http.post<String>(
      `${configuration.apiUrl}Scheduler/BlockTemplateAppointment`, posteddata);
  }

  getAppCountbyTemplateId(templateId: number, userId: string): Observable<number> {
    return this.http.get<number>(
      `${configuration.apiUrl}Scheduler/GetAppCountbyTemplate?templateId=${templateId}&&userid=${encodeURIComponent(userId)}`);
  }

  getPatientBoardCount(appDate: string, userList: string, schdflag: boolean, appstatusList: string): Observable<number> {
    const posteddata = {
      appDate: appDate,
      userList: userList,
      schdflag: true,
      clinictimeduration: Defaults.clinictimeduration,
      locationId: sessionStorage.getItem("LocationId"),
      appstatusList: appstatusList
    }
    return this.http.post<number>(
      `${configuration.apiUrl + 'Scheduler/PatientBoardCount'}`, posteddata,);
  }

  blockAppointmentSlots(providerId: string, currDate: any, startTime: any, endTime: any, locationId: number, holidayreason: string): any {
    ;
    const appreq = {
      providerId: providerId,
      appDate: currDate,
      startTime: startTime,
      endTime: endTime,
      locationId: locationId,
      holidayreason: holidayreason,
      userId: encodeURIComponent(sessionStorage.getItem("userId"))
    }
    return this.http.post<string>(
      `${configuration.apiUrl}Scheduler/BlockSlots`, appreq,
      {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });

    // return this.http.post<string>(
    //   `${configuration.apiUrl}Scheduler/BlockSlots?providerId=${encodeURIComponent(providerId)}&&appDate=${currDate}&&startTime=${startTime}&&endTime=${endTime}&&locationId=${locationId}`,{holidayreason:holidayreason},
    //   { headers: new HttpHeaders({ 'content-Type': 'application/json' })
    // });
    // const params=new HttpParams()
    // .set("pholidayname","Test");

    // return this.http.get<string>(
    //   `${configuration.apiUrl + 'Scheduler/BlockSlots'}?providerId=${encodeURIComponent(providerId)}&&appDate=${currDate}&&startTime=${startTime}&&endTime=${endTime}&&locationId=${locationId}`,
    //    { 
    //      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    //      params:params

    //    }
    // );
  }

  getservercurrentdate() {
    // if(sessionStorage.getItem("LocationId"))
    //     return this.http.get<string>(`${configuration.apiUrl}Admin/ServerDate?locationId=${sessionStorage.getItem("LocationId")}`);
    // else
    //      return null
    return this.shrddrv.getservercurrentdate();
  }

  getProviderHolidays(providerId: string, currDate: Date, locationId: number): Observable<boolean> {
    const postedData = {
      providerId: encodeURIComponent(providerId),
      currentDate: currDate,
      locationId: locationId
    }
    return this.http.post<boolean>(
      `${configuration.apiUrl + 'Scheduler/ProviderBlock'}`, postedData);
  }

  getCalendarslot(locationId: number, startTime: string, endTime: string): Observable<boolean> {
    const postDate = {
      locationId: locationId,
      startTime: startTime,
      endTime: endTime
    }
    return this.http.post<boolean>(
      `${configuration.apiUrl}Scheduler/CheckCustomSlot`, postDate);
  }


  getPatientFutureAppointments(patId: number, locationId: number, appId: string): Observable<IAppointmentData[]> {
    const postDate = {
      patId: patId,
      locationId: locationId,
      appId: appId
    }
    return this.http.post<IAppointmentData[]>(
      `${configuration.apiUrl + 'Scheduler/GetPatFutureAppointments'}`, postDate);
  }
  getPatientFutureAppointmentsCount(patId: number, locationId: number, appId: string): Observable<any> {
    const postData = {
      patId: patId,
      locationId: locationId,
      appId: appId
    }
    return this.http.post<any>(
      `${configuration.apiUrl + 'Scheduler/GetPatFutureAppointmentsCount'}`, postData);
  }
  //get export excel appt. worklist
  getExportExcelApptworklist(userlist: string, locationId: number): Observable<IExportexcelWorklist[]> {
    const posteddata = {
      userid: encodeURIComponent(sessionStorage.getItem("userId")),
      userlist: encodeURIComponent(userlist).toString(),
      locationId: sessionStorage.getItem("LocationId")
    }
    return this.http.post<IExportexcelWorklist[]>(
      `${configuration.apiUrl}Scheduler/ExportExcelApptworklist`, posteddata,
      {
        headers: new HttpHeaders({ 'content-Type': 'application/json' })
      });
  }

  // get encounter for appointment Id
  getEncounterIdByAppId(appId: string): Observable<string> {
    return this.http.get<string>(
      `${configuration.clinicapiUrl + 'Encounter/EncounterAppointment'}?appid=${appId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  GetExportListValueTService(scheduleReportsExcel: ScheduleReportExcelRequest): any {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/GetScheduleReportsExport'}`, scheduleReportsExcel, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetScheduleReportAppointments2CTService(StartDate: string, EndDate: string, LocId: string, ProId: string): Observable<number> {
    const posteddata = {
      StartDate: StartDate,
      EndDate: EndDate,
      LocId: LocId,
      ProId: ProId
    }
    return this.http.post<number>(
      `${configuration.apiUrl + 'Scheduler/GetScheduleReportAppointments2C'}`, posteddata);
  }
  GetScheduleReportAppointments2BTService(date: string, locationId: string, procId: string): Observable<number> {
    const posteddata = {
      date: date,
      locationId: locationId,
      procId: procId
    }
    return this.http.post<number>(
      `${configuration.apiUrl + 'Scheduler/SchedulerReportsService2B'}`, posteddata);
  }
  GetScheduleReportAppointments2ATService(StartDate: string, EndDate: string, LocId: string, ProId: string): Observable<number> {
    const posteddata = {
      StartDate: StartDate,
      EndDate: EndDate,
      LocId: LocId,
      ProId: ProId
    }
    return this.http.post<number>(
      `${configuration.apiUrl + 'Scheduler/GetScheduleReportAppointments2A'}`, posteddata);
  }
  GetNextAppointmentByPatId(patId: number, appId: string): Observable<NextAppointment> {
    const posteddata = {
      appId: appId,
      patId: patId,
      userId: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<NextAppointment>(
      `${configuration.apiUrl + 'Scheduler/NextAppointment'}`, posteddata);
  }

  GetAppointmentStatusLogs(appId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${configuration.apiUrl + 'Scheduler/GetAppointmentStatusLogs'}?appointmentID=${appId}`);

  }

  GetAppointmentcommentLogs(appId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${configuration.apiUrl + 'Scheduler/GetAppointmentcommentLogs'}?appointmentID=${appId}`);

  }

  GetAppointmentProcedureLogs(appId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${configuration.apiUrl + 'Scheduler/GetAppointmentProcedureLogs'}?appointmentID=${appId}`);

  }

  AddAppointmentStatusLogs(appointmentInfo: IAppointmentStatusLogs[]): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(appointmentInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/AddAppointmentStatusLogs'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  AddAppointmentCommentLogs(appointmentInfo: IAppointmentStatusLogs[]): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(appointmentInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/AddAppointmentCommentLogs'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  AddAppointmentProcedureLogs(appointmentInfo: IAppointmentStatusLogs[]): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(appointmentInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/AddAppointmentProcedureLogs'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  CallStatus(callstatus: number, iscallwait: boolean, appId: string, type: string): Observable<number> {
    const posteddata = {
      callComplete: callstatus,
      iscallWait: iscallwait,
      appId: appId,
      type: type,
      userid: encodeURIComponent(sessionStorage.getItem("userId")),

    }
    return this.http.post<number>(`${configuration.apiUrl + 'Scheduler/CallStatus'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });

  }

  SendSMS(toNum: string, msg: string, AppId: string, twillioNum: string, ele: IAppointmentDataPB): Observable<string> {
    const postedData = {
      toPhoneNum: toNum,
      message: msg,
      appId: AppId,
      twillioPhoneNum: encodeURIComponent(twillioNum),
      appStatus: ele.patAppStatus,
      createdBy: encodeURIComponent(sessionStorage.getItem("userId")),
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/SendSMS'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'No-Auth': 'True' })
    });

  }

  //****Save white list IPAddress list */
  InsertIPAddresslist(IPAddress, dbOperation, ipAddressId): Observable<string> {
    const postedData = {
      IPAddress: IPAddress,
      facilityId: sessionStorage.getItem("FacilityId"),
      locationId: sessionStorage.getItem("LocationId"),
      userId: encodeURIComponent(sessionStorage.getItem("userId")),
      dbOperation: dbOperation,
      IPAddressId: ipAddressId
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Scheduler/InsertIPAddress'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetWhitelistIPAddress(): Observable<IPAddressList[]> {
    return this.http.get<IPAddressList[]>(
      `${configuration.apiUrl + 'Scheduler/GetWhiteListIPAddress'}?FacilityId=${sessionStorage.getItem("FacilityId")}`);

  }

  //Move appointments
  moveAppointmentbyDate(providerId: string, currDate: any, toDate: any, locationId: number): Observable<String> {
    const posteddata = {
      providerId: providerId,
      locationId: locationId,
      appDate: currDate,
      toDate: toDate,
      userId: encodeURIComponent(sessionStorage.getItem("userId"))
    }
    return this.http.post<String>(
      `${configuration.apiUrl}Scheduler/MoveAppointment`, posteddata);
  }

  SendTelemedicineLink(appObj: IAppointmentData): Observable<boolean> {
    const posteddata = {
      inputdata: JSON.stringify(appObj)
    }
    return this.http.post<boolean>(`${configuration.apiUrl + 'Scheduler/TeleLink'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPatientReferralFollowUpComment(appointmentId: string): Observable<string> {
    return this.http.get<string>(
      `${configuration.apiUrl + 'Scheduler/PatientReferralFollowUpComment'}?appointmentId=${appointmentId}`);
  }

}
